<template>
  <section class="team-section d-none">
    <v-carousel
      cycle
      height="400"
      hide-delimiter-background
      show-arrows-on-hover
      :show-arrows="false"
    >
      <!-- Each carousel item will hold 3 cards in a row -->
      <v-carousel-item
        v-for="(chunk, index) in chunkedServices"
        :key="index"
      >
        <v-row>
          <v-col
            v-for="(service, i) in chunk"
            :key="i"
            cols="12"
            sm="6"
            md="4"
          >
            <div class="team-card">
              <div
                class="team-image"
                :style="{ backgroundImage: `url(${service.image})` }"
              >
                <div class="role-badge">
                  {{ service.role }}
                </div>
                <div class="name-badge">
                  {{ service.name }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </section>

  <section style=" background-color: #e11c09 !important;   padding: 50px 0px 50px 0px;
    z-index: 9;"
                class=" mt-4 elementor-section elementor-top-section elementor-element elementor-element-1da8388 elementor-section-stretched secondary-bg elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="1da8388" data-element_type="section"
                data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
                <div class="elementor-container elementor-column-gap-default">
                  <div
                    class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-bbd4823"
                    data-id="bbd4823" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-0a761d5 elementor-widget elementor-widget-counter-box"
                        data-id="0a761d5" data-element_type="widget" data-widget_type="counter-box.default">
                        <div class="elementor-widget-container">

                          <div class="counter text-white ">
                            <div class="counter-icon"><i class="flaticon flaticon-global"></i></div>
                            <div class="counter-desc">
                              <span class="count-number" data-count="15">15</span>
                              <span> k </span>
                              <h5>Worldwide Clients</h5>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-904bce4"
                    data-id="904bce4" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-ce3892a elementor-widget elementor-widget-counter-box"
                        data-id="ce3892a" data-element_type="widget" data-widget_type="counter-box.default">
                        <div class="elementor-widget-container">

                          <div class="counter text-white ">
                            <div class="counter-icon"><i class="flaticon flaticon-team"></i></div>
                            <div class="counter-desc">
                              <span class="count-number" data-count="142">142</span>
                              <span> + </span>
                              <h5>Expert Company Staffs</h5>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-03c69cb"
                    data-id="03c69cb" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-0d52238 elementor-widget elementor-widget-counter-box"
                        data-id="0d52238" data-element_type="widget" data-widget_type="counter-box.default">
                        <div class="elementor-widget-container">

                          <div class="counter text-white ">
                            <div class="counter-icon"><i class="flaticon flaticon-global-services"></i></div>
                            <div class="counter-desc">
                              <span class="count-number" data-count="223">223</span>
                              <span> + </span>
                              <h5>Worldwide Branches</h5>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-73df84f"
                    data-id="73df84f" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-ed55172 elementor-widget elementor-widget-counter-box"
                        data-id="ed55172" data-element_type="widget" data-widget_type="counter-box.default">
                        <div class="elementor-widget-container">

                          <div class="counter text-white ">
                            <div class="counter-icon"><i class="flaticon flaticon-delivery-man"></i></div>
                            <div class="counter-desc">
                              <span class="count-number" data-count="10">10</span>
                              <span> M </span>
                              <h5>Successful Delivery</h5>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
</template>

<script>
export default {
  name: "TeamSlider",
  data() {
    return {
      services: [
        {
          role: "JR. MANAGER",
          name: "Kayley Rain",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team05.jpg"
        },
        {
          role: "MANAGER",
          name: "Cillian Murphy",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team02.jpg"
        },
        {
          role: "DRIVER",
          name: "Soumya James",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team05.jpg"
        },
        {
          role: "SUPERVISOR",
          name: "Alex Carter",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team02.jpg"
        },
        {
          role: "HELPER",
          name: "Sam Wilson",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team05.jpg"
        },
        {
          role: "COORDINATOR",
          name: "Emily Rose",
          image:
            "https://moverz.themeht.com/wp-content/uploads/2024/10/team02.jpg"
        }
      ]
    };
  },
  computed: {
    chunkedServices() {
      const chunkSize = 3;
      return Array.from(
        { length: Math.ceil(this.services.length / chunkSize) },
        (v, i) => this.services.slice(i * chunkSize, i * chunkSize + chunkSize)
      );
    }
  }
};
</script>

<style scoped>
.team-card {
  /* border-radius: 12px; */
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.team-image {
  height:400px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.role-badge {
  position: absolute;
  bottom: 50px;
  left: 10px;
  background: #0b1521;
  color: #fff;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}

.name-badge {
  position: absolute;
  bottom: 20px;
  left: 10px;
  background: #fff;
  color: #001e50;
  padding: 6px 14px;
  font-weight: bold;
  font-size: 16px;
}
</style>
